import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  selectMockModeState,
  selectMockedAppView,
  selectMockedUserView,
  requestUpdateMockAccessAppView,
  requestUpdateMockAccessUserView,
  requestUpdateMockAccessIsInMockMode,
} from '~/store/app/mocks';

export const useMockMode = () => {
  const dispatch = useDispatch();

  const isInMockMode = useSelector(selectMockModeState);
  const mockedAppView = useSelector(selectMockedAppView);
  const mockedUserView = useSelector(selectMockedUserView);

  const updateUserView = bindActionCreators(requestUpdateMockAccessUserView, dispatch);
  const updateAppView = bindActionCreators(requestUpdateMockAccessAppView, dispatch);
  const updateIsInMockMode = bindActionCreators(requestUpdateMockAccessIsInMockMode, dispatch);

  return {
    isInMockMode,
    mockedAppView,
    mockedUserView,
    updateUserView,
    updateAppView,
    updateIsInMockMode,
  };
};
